import { useState } from 'react';
import { Eye, EyeOff, Mail, Lock, ArrowLeft, Palette, Music, Camera } from 'lucide-react';
import Footer from '../components/Footer';
import leadLoginQueries from '../../queries/leadLoginQueries';
import MainHeader from '../components/MainHeader';
import RouteConstants from '../../constant/Routeconstant';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoginLead } from '../../redux/reducers/leadReducers';

export default function LeadLogin() {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [forgotEmail, setForgotEmail] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // React Query hooks for API calls
  const loginMutation = leadLoginQueries.useLeadLogin((data) => {
    console.log('Login successful:', data);
    
    
    if (data.token) {
      // localStorage.setItem('leadToken', data.token);
      // localStorage.setItem('leadUser', JSON.stringify(data.user));
      setMessage('Login successful! Redirecting...');
      setMessageType('success');
      dispatch(setLoginLead(data));
      setTimeout(() => {
      // Replace with your routing logic
      navigate(RouteConstants.LEADDASH)
    }, 1500);
    }
    
    // Redirect or handle successful login
    
  });

  const forgotPasswordMutation = leadLoginQueries.useForgotpassword((data) => {
    console.log('Forgot password response:', data);
    setMessage(data.message || 'Password reset instructions sent to your email');
    setMessageType('success');
      setIsLogin(true);
      setForgotEmail('');
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async () => {
    if (!formData.email || !formData.password) {
      setMessage('Please fill in all fields');
      setMessageType('error');
      return;
    }
    
    setMessage('');
    setMessageType('');
    
    try {
      await loginMutation.mutateAsync({
        email: formData.email.trim().toLowerCase(),
        password: formData.password
      });
    } catch (error) {
      console.error('Login error:', error);
      setMessage(error.response?.data?.message || 'Login failed. Please try again.');
      setMessageType('error');
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      setMessage('Please enter your email address');
      setMessageType('error');
      return;
    }
    
    setMessage('');
    setMessageType('');
    
    try {
      await forgotPasswordMutation.mutateAsync({
        email: forgotEmail.trim().toLowerCase()
      });
    } catch (error) {
      console.error('Forgot password error:', error);
      setMessage(error.response?.data?.message || 'Failed to send reset instructions. Please try again.');
      setMessageType('error');
    }
  };

  const isLoading = loginMutation.isLoading || forgotPasswordMutation.isLoading;

  const FloatingElements = () => (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute top-20 left-10 text-yellow-300/20 animate-bounce">
        <Palette size={40} />
      </div>
      <div className="absolute top-32 right-16 text-red-300/20 animate-pulse">
        <Music size={35} />
      </div>
      <div className="absolute bottom-32 left-20 text-green-300/20 animate-bounce delay-300">
        <Camera size={30} />
      </div>
      <div className="absolute bottom-20 right-10 text-orange-300/20 animate-pulse delay-500">
        <Palette size={45} />
      </div>
      <div className="absolute top-1/2 left-8 text-pink-300/20 animate-bounce delay-700">
        <Music size={25} />
      </div>
    </div>
  );

  return (
    <>
    <MainHeader />
    {/* <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-teal-800 to-cyan-900 flex items-center justify-center p-4 relative overflow-hidden"> */}
    <div className="min-h-screen bg-gradient-to-br from-yellow-300 via-yellow-400 to-yellow-500 flex items-center justify-center p-4 relative overflow-hidden">

      {/* Background Pattern */}
      {/* <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div> */}
      
      <FloatingElements />

      <div className="w-full max-w-md relative z-10">
        {/* Main Card */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-white/10">
          {isLogin ? (
            // Login Form
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                Login
              </h2>
              
              {message && (
                <div className={`mb-4 p-3 rounded-lg text-sm ${
                  messageType === 'success' 
                    ? 'bg-emerald-100 border border-emerald-300 text-emerald-700'
                    : 'bg-red-100 border border-red-300 text-red-700'
                }`}>
                  {message}
                </div>
              )}

              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                      placeholder="Enter your email"
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Password
                  </label>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      className="w-full pl-11 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                      placeholder="Enter your password"
                      disabled={isLoading}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                      disabled={isLoading}
                    >
                      {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300 text-emerald-600 shadow-sm focus:border-emerald-300 focus:ring focus:ring-emerald-200 focus:ring-opacity-50"
                      disabled={isLoading}
                    />
                    <span className="ml-2 text-sm text-gray-600">Remember me</span>
                  </label>
                  <button
                    type="button"
                    onClick={() => {
                      setIsLogin(false);
                      setMessage('');
                      setMessageType('');
                    }}
                    className="text-sm text-emerald-600 hover:text-emerald-800 font-medium transition-colors disabled:opacity-50"
                    disabled={isLoading}
                  >
                    Forgot password?
                  </button>
                </div>

                <button
                  onClick={handleLogin}
                  disabled={isLoading}
                  className="w-full bg-gradient-to-r from-red-600 to-red-700 text-white py-3 px-4 rounded-lg hover:from-emerald-700 hover:to-teal-700 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 transition-all transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                >
                  {isLoading ? (
                    <div className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                      Signing In...
                    </div>
                  ) : (
                    'Sign In'
                  )}
                </button>
              </div>
            </div>
          ) : (
            // Forgot Password Form
            <div>
              <div className="flex items-center mb-6">
                <button
                  onClick={() => {
                    setIsLogin(true);
                    setMessage('');
                    setMessageType('');
                    setForgotEmail('');
                  }}
                  className="mr-3 p-2 rounded-full hover:bg-gray-100 transition-colors disabled:opacity-50"
                  disabled={isLoading}
                >
                  <ArrowLeft className="w-5 h-5 text-gray-600" />
                </button>
                <h2 className="text-2xl font-bold text-gray-800">
                  Reset Password
                </h2>
              </div>

              <p className="text-gray-600 mb-6">
                Enter your email address and we'll send you a new password.
              </p>

              {message && (
                <div className={`mb-4 p-3 rounded-lg text-sm ${
                  messageType === 'success' 
                    ? 'bg-emerald-100 border border-emerald-300 text-emerald-700'
                    : 'bg-red-100 border border-red-300 text-red-700'
                }`}>
                  {message}
                </div>
              )}

              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      type="email"
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                      className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                      placeholder="Enter your email address"
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <button
                  onClick={handleForgotPassword}
                  disabled={isLoading}
                  className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white py-3 px-4 rounded-lg hover:from-emerald-700 hover:to-teal-700 focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 transition-all transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                >
                  {isLoading ? (
                    <div className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                      Sending...
                    </div>
                  ) : (
                    'Send New Password'
                  )}
                </button>
              </div>
            </div>
          )}
        </div>         
      </div>
    </div>
    <Footer />
    </>
  );
}